import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserPass, User, Tabla } from '../models/login';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private http: HttpClient) {
  }


	getLogin(user: UserPass): Observable<User> {
		return this.http.post<User>(`${environment.apiUrl}Login/Authenticate`, user);
	}
	changePass(user: UserPass): Observable<boolean> {
		return this.http.post<boolean>(`${environment.apiUrl}Login/ChangePass`, user);
	}
	getMaestro(): Observable<Tabla[]> {
		return this.http.get<Tabla[]>(`${environment.apiUrl}Maestro`);
	}

}
